import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import UMODetailView from '../UMODetailView';

function UMODetailModal({
                          dispatch,
                          umoID,
                          toggleUMODetailView,
                          selectedWorkspaceData,
                          retrieveUMOs,
}) {
  return (
    <Modal
      show={umoID !== undefined}
      onHide={() => {
        toggleUMODetailView(false);
        // dispatch(retrieveUMOs());
      }}
      dialogClassName="umo-detail-modal"
    >
      <UMODetailView
        umoID={umoID}
        toggleUMODetailView={toggleUMODetailView}
        selectedWorkspaceData={selectedWorkspaceData}
        dispatch={dispatch}
        retrieveUMOs={retrieveUMOs}
      />
    </Modal>
  );
}

UMODetailModal.propTypes = {
  umoID: PropTypes.string,
  toggleUMODetailView: PropTypes.func,
  dispatch: PropTypes.func,
  retrieveUMOs: PropTypes.func,
  selectedWorkspaceData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }),
};

export default UMODetailModal;
